module.exports = __webpack_public_path__ + "img/logo-but-1.ba3044dd.png";